import React, { SVGProps } from 'react'
const SvgSidenavCardsActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="evenodd"
      d="M1.25 5.667A2.417 2.417 0 0 1 3.667 3.25h12.666a2.417 2.417 0 0 1 2.417 2.417v8.666a2.417 2.417 0 0 1-2.417 2.417H3.667a2.417 2.417 0 0 1-2.417-2.417V5.667Zm2.417-.917a.917.917 0 0 0-.917.917v1.012h14.5V5.667a.917.917 0 0 0-.917-.917H3.667Zm7.193 7.096a.625.625 0 0 0 0 1.25h3.94a.625.625 0 1 0 0-1.25h-3.94Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavCardsActive
